export const initialState = {
  isFetching: false,
  items: [],
}

export const setProducts = (state, payload) => (
  { ...state, items: payload, isFetching: false }
)

export const setFetchingStatus = (state, payload) => (
  { ...state, isFetching: payload }
)

export const reset = () => initialState
